module.exports = ".full-width {\n  width: 100%;\n}\n\n.form-transferir {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  min-width: 380px;\n}"